import { createApp } from 'vue';
import VirtualVisitComponent from './offer/virtual-visit-component.vue';
import eventBus from '../_00_elements/tools/event-bus';

export default function () {
  const component = {
    components: {
      VirtualVisitComponent,
    },
    data() {
      return {
        isVirtualVisitModalOpened: false,
      };
    },
    mounted() {
      eventBus.addEventListener('virtualvisit-open', () => {
        this.showVirtualVisitModal();
      });
    },
    methods: {
      /**
       * showVirtualVisitModal
       *
       * @description Show Gallery Modal
       */
      showVirtualVisitModal() {
        this.isVirtualVisitModalOpened = true;
      },
      /**
       * closeVirtualVisitModal
       *
       * @description Hide VirtualVisit Modal
       */
      closeVirtualVisitModal() {
        this.isVirtualVisitModalOpened = false;
      },
    },
  };

  return createApp(component).mount('.virtualvisit');
}
